import {make} from "vuex-pathify";
import moment from "moment";
import BotService from "@/services/bot.service";
import router from "@/router";
import AppService from "@/services/app.service";
import ReportService from "@/services/report.service";

const state = () => ({
    filter: {
        agentEmail: null,
        date: moment().format('YYYY-MM-DD'),
    },
    skillsFilterItems: [],
})
const mutations = {
    ...make.mutations(state),
}
const actions = {
    ...make.actions(state),
    fetchAutoAssignStatusManage({commit}) {
        const botCode = router.currentRoute.params.bot_code;
        BotService.getAutoAssignStatus_manage(botCode)
            .then(res => {
                commit('SET_AUTO_ASSIGN_STATUS_MANAGE', res.data);
            })
            .catch(err => {
                AppService.toastError("Error", err.message);
            })
    },
    fetchOverviewReport({commit, state}) {
        const botCode = router.currentRoute.params.bot_code;
        ReportService.Overview(botCode, state.filter.channel, state.filter.skills, state.filter.from, state.filter.to)
            .then(res => {
                commit('SET_OVERVIEW_REPORT', res.data);
            })
    }
}
const getters = {
    skillsFilterItems: state => {
        if (state.autoAssignStatusManage) {
            const categories = state.autoAssignStatusManage.rs_categories;
            return _.map(categories, o => {
                return {text: o.name, value: o.id}
            })
        }
        return [];
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}